(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('ExternalResourceDialogController', ExternalResourceDialogController);

    ExternalResourceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ExternalResource', 'AdvertisingSource'];

    function ExternalResourceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ExternalResource, AdvertisingSource) {
        var vm = this;

        vm.externalResource = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.advertisingsources = AdvertisingSource.query();
        // Flush healthIndicator&lastModified
        vm.externalResource.healthIndicator = null;
        vm.externalResource.lastModified = null;

        // FIXME найти лучшую конфигурацию по настройке времени.
        vm.datePickerOptions = {
            enableDate: false,
            mode: 'hour',
            minMode: 'minute',
            maxMode: 'hour'
        };
        vm.updateLoadingType = updateLoadingType;
        vm.charsets = ["UTF-8", "cp1251"];
        function updateLoadingType() {
            if (vm.externalResource.loadingType == 0) {
                if (vm.externalResource.loadTime == null || vm.externalResource.loadTime == '') {
                    vm.externalResource.loadTime = 0;
                }
            } else {
                if (vm.externalResource.period == null || vm.externalResource.period == '') {
                    vm.externalResource.period = 0;
                }
            }
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.externalResource.id !== null) {
                ExternalResource.update(vm.externalResource, onSaveSuccess, onSaveError);
            } else {
                ExternalResource.save(vm.externalResource, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:externalResourceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.loadTime = false;
        vm.datePickerOpenStatus.lastDownload = false;
        vm.datePickerOpenStatus.lastSuccessProcessing = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
